import classnames from 'classnames/bind';
import {
  DURATION_MS,
  SEGMENTS_GAP,
} from '@/_components/promo-zone/_components/card/_components/slider/_components/_constants';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'SegmentedProgressBar';

type TProps = {
  totalSlides: number;
  activeIndex: number;
  onSegmentClick: (index: number) => void;
};

export const SegmentedProgressBar = ({
  totalSlides,
  activeIndex,
  onSegmentClick,
}: TProps) => {
  return (
    <div className={cn(BLOCK_NAME)}>
      {Array.from({ length: totalSlides }).map((_, index) => {
        const handleSegmentClick = () => onSegmentClick(index);

        return (
          <button
            key={index}
            className={cn(`${BLOCK_NAME}__segment`, {
              [`${BLOCK_NAME}__segment--active`]: index < activeIndex,
            })}
            onClick={handleSegmentClick}
            style={{
              flex: `1 0 calc((100% - ${(totalSlides - 1) * SEGMENTS_GAP}px) / ${totalSlides})`,
            }}
            type="button"
          >
            {index === activeIndex && (
              <div
                className={cn(`${BLOCK_NAME}__progress`)}
                style={{
                  animationDuration: `${DURATION_MS}ms`,
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};
